<!-- 支付结果页面 -->
<template>
    <div class="result-container text-center">
      <img class="state-img" :src="result == 'Accept' ? successImg : failImg" />
      <div class="rem32 mt15">
        <span>{{ result == 'Accept' ? '审核通过' : '审核拒绝' }}</span>
      </div>
      <div class="rem30 mt35 text-left">
          <p class="lh21 text-center">{{ msg }}</p>
      </div>
      <!-- <div class="result-btn" v-if="twoElements == 1">
        <van-button round block color="#4D7BFE" class="btn" @click="back()">
          <span class="rem34">返回上一步</span>
        </van-button>
      </div> -->
    </div>
  </template>

  <script>
  import Vue from 'vue'
  import { Button } from 'vant'
  
  Vue.use(Button)
  export default {
    data() {
      return {
        successImg: require('@/assets/images/ryd/examine-agree.png'),
        failImg: require('@/assets/images/ryd/examine-refuse.png'),
        result: 'Accept',
        twoElements: 0,
        msg: ''
      }
    },
    async created() {
        let { twoElements, result } = this.$route.query
        this.result = result || ''
        // this.twoElements = twoElements || 0
        this.msg = this.result == 'Accept' ? '恭喜您，审核通过，请前往ryd小程序发起分期申请。' : '抱歉，您的综合评分不足，暂不符合分期购买要求！'
    },
    methods: {
      back() {
        window.history.back()
      },
    },
  }
  </script>
  
  <style lang="less" scoped>
  .result-container {
    padding: 0 0.42rem /* 21/50 */;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    position: relative;
    .state-img {
      margin-top: 1rem;
    //   width: 3.42rem;
      height: 3.32rem;
    }
    .result-btn {
      position: absolute;
      margin-top: 0.82rem /* 41/50 */;
      bottom: 2.3rem;
      width: calc(100% - 0.84rem);
    }
    .btn {
      margin-top: 0.48rem /* 24/50 */;
    }
  }
  </style>
  
